import { useSelector } from 'react-redux'
import { useParams } from 'react-router-dom'

import Page from '@/components/content/Page'
import { Translation } from '@/components/i18n/Translation'
import LoaderCircle from '@/components/util/LoaderCircle'
import { getIsPending, getSubscriptionOrder } from '@/ducks/subscriptionOrderReducer'
import withSubscriptionOrderLoaded from '@/hocs/withSubscriptionOrderLoaded'
import { getSubscriptionOrderStatusTextId, getSubscriptionOrderTypeTextId } from '@/util/orders'

import SubscriptionOrderCommunications from './SubscriptionOrderCommunications'
import SubscriptionOrderDealerInstructions from './SubscriptionOrderDealerInstructions'
import SubscriptionOrderDetails from './SubscriptionOrderDetails'
import { SubscriptionOrderInputs } from './SubscriptionOrderInputs'
import SubscriptionOrderOptions from './SubscriptionOrderOptions'
import SubscriptionOrderUserDetails from './SubscriptionOrderUserDetails'

import './subscription-order-page.scss'

const SubscriptionOrderPage = () => {
  const params = useParams()
  // @ts-ignore
  const orderId = parseInt(params.order_id)

  const isPending = useSelector(getIsPending)
  const { status, subscription_service_id } = useSelector(getSubscriptionOrder)

  return (
    <Page className="subscription-order">
      <h1>
        {/* @ts-ignore */}
        <Translation id="Subscription Order {orderId}" orderId={orderId} />
      </h1>

      {isPending ? (
        <LoaderCircle />
      ) : (
        <>
          <h2>
            <Translation id={getSubscriptionOrderTypeTextId(subscription_service_id)} /> -{' '}
            <Translation id={getSubscriptionOrderStatusTextId(status)} />
          </h2>

          <SubscriptionOrderOptions />

          <SubscriptionOrderDealerInstructions />

          <div className="sections">
            <SubscriptionOrderUserDetails />

            <SubscriptionOrderDetails />

            <SubscriptionOrderInputs />
            {/* @ts-ignore */}
            <SubscriptionOrderCommunications />
          </div>
        </>
      )}
    </Page>
  )
}

export default withSubscriptionOrderLoaded(SubscriptionOrderPage)
